"use strict";
import { getStatPointCost } from "../../js/gamedata/statallocation";

ui.loadTemplateFile("character.html");

class CharacterDialog extends Dialog {
    _element: any;
    _titleBar: any;
    _level: any;
    _job: any;
    _clan: any;
    _hp: any;
    _mp: any;
    _xp: any;
    _zuly: any;
    _strength: any;
    _dexterity: any;
    _intelligence: any;
    _concentration: any;
    _charm: any;
    _sense: any;
    _attack: any;
    _accuracy: any;
    _critical: any;
    _criticalDamage: any;
    _piercePhysical: any;
    _pierceMagical: any;
    _attackSpeed: any;
    _pvmOffense: any;
    _pvpOffense: any;
    _mpCost: any;
    _summonGauge: any;
    _defense: any;
    _magicDefense: any;
    _dodge: any;
    _blockRate: any;
    _blockPhysical: any;
    _blockMagical: any;
    _runSpeed: any;
    _pvmDefense: any;
    _pvpDefense: any;
    _hpRecovery: any;
    _mpRecovery: any;
    _statPoints: any;
    _data: any;

    constructor(mycharacter: any) {
        super("character.html");

        // Char Info
        this._level = ui.charstat(this, ".stat.level");
        this._job = ui.charstat(this, ".stat.job");
        this._clan = ui.charstat(this, ".stat.clan");

        // Bars
        this._hp = ui.charstat(this, ".stat.health");
        this._mp = ui.charstat(this, ".stat.mana");
        this._xp = ui.charstat(this, ".stat.exp");

        // Currencies
        this._zuly = ui.charstat(this, ".stat.zuly");

        // Column 1
        this._strength = ui.charstat(this, ".stat.strength");
        this._dexterity = ui.charstat(this, ".stat.dexterity");
        this._intelligence = ui.charstat(this, ".stat.intelligence");
        this._concentration = ui.charstat(this, ".stat.concentration");
        this._charm = ui.charstat(this, ".stat.charm");
        this._sense = ui.charstat(this, ".stat.sense");
        this._statPoints = ui.label(this, ".label.stat-points-value");

        [
            [this._strength, 0],
            [this._dexterity, 1],
            [this._intelligence, 2],
            [this._concentration, 3],
            [this._charm, 4],
            [this._sense, 5],
        ].forEach(([stat, statType]) => {
            stat.onAllocate(() => netGame.allocateStat(statType, 1));
        });

        // Colum 2
        this._attack = ui.charstat(this, ".stat.attack");
        this._accuracy = ui.charstat(this, ".stat.accuracy");
        this._critical = ui.charstat(this, ".stat.critical");
        this._criticalDamage = ui.charstat(this, ".stat.critical-damage");
        this._piercePhysical = ui.charstat(this, ".stat.pierce-physical");
        this._pierceMagical = ui.charstat(this, ".stat.pierce-magical");
        this._attackSpeed = ui.charstat(this, ".stat.attack-speed");
        this._pvmOffense = ui.charstat(this, ".stat.pvm-offense");
        this._pvpOffense = ui.charstat(this, ".stat.pvp-offense");
        this._mpCost = ui.charstat(this, ".stat.mp-cost");
        this._summonGauge = ui.charstat(this, ".stat.summon-gauge");

        // Column 3
        this._defense = ui.charstat(this, ".stat.defense");
        this._magicDefense = ui.charstat(this, ".stat.magic-defense");
        this._dodge = ui.charstat(this, ".stat.dodge");
        this._blockRate = ui.charstat(this, ".stat.block-rate");
        this._blockPhysical = ui.charstat(this, ".stat.block-physical");
        this._blockMagical = ui.charstat(this, ".stat.block-magical");
        this._runSpeed = ui.charstat(this, ".stat.run-speed");
        this._pvmDefense = ui.charstat(this, ".stat.pvm-defense");
        this._pvpDefense = ui.charstat(this, ".stat.pvp-defense");
        this._hpRecovery = ui.charstat(this, ".stat.hp-recovery");
        this._mpRecovery = ui.charstat(this, ".stat.mp-recovery");

        // Set units
        this._critical.unit("%");
        this._criticalDamage.unit("%");
        this._attackSpeed.unit("%");
        this._pvmOffense.unit("%");
        this._pvpOffense.unit("%");
        this._blockRate.unit("%");
        this._pvmDefense.unit("%");
        this._pvpDefense.unit("%");
        this._hpRecovery.unit(" / Sec");
        this._mpRecovery.unit(" / Sec");
        this._data = mycharacter;
        this._data.on("changed", this._update.bind(this));
        this._update();
    }

    _update() {
        const char = this._data;
        const stats = char.stats;

        this._level.value(char.level);
        this._job.value(char.job);

        this._hp.max(char.calculatedStats.maxHp || stats.getMaxHp());
        this._hp.value(char.hp);
        this._mp.max(char.calculatedStats.maxMp || stats.getMaxMp());
        this._mp.value(char.mp);
        this._xp.max(stats.getNeedRawExp());
        this._xp.value(char.xp);

        this._zuly.value(char.inventory.money.toString());

        // Base value plus the equipment/gem bonus from the server, e.g. "15 (+5)".
        const bonus = MC.calculatedStats.bonusStats || {};
        const withBonus = (base: number, extra: number) => (extra ? `${base} (+${extra})` : base);
        this._strength.value(withBonus(stats.str, bonus.str));
        this._dexterity.value(withBonus(stats.dex, bonus.dex));
        this._intelligence.value(withBonus(stats.int, bonus.int));
        this._concentration.value(withBonus(stats.con, bonus.con));
        this._charm.value(withBonus(stats.cha, bonus.cha));
        this._sense.value(withBonus(stats.sen, bonus.sen));

        const availableStatPoints = Math.max(0, Number(char.statPoints) || 0);
        this._statPoints.text(availableStatPoints.toString());
        [
            [this._strength, stats.str],
            [this._dexterity, stats.dex],
            [this._intelligence, stats.int],
            [this._concentration, stats.con],
            [this._charm, stats.cha],
            [this._sense, stats.sen],
        ].forEach(([stat, value]) => {
            const cost = getStatPointCost(value);
            stat.allocationCost(cost);
            stat.allocationAvailable(availableStatPoints >= cost && value < 999);
        });

        this._attack.value(MC.calculatedStats.attackPower);
        this._accuracy.value(MC.calculatedStats.accuracy);
        this._critical.value(_makePerc(MC.calculatedStats.critical, 250));
        this._attackSpeed.value(MC.calculatedStats.attackSpeed);
        this._mpCost.value(MC.calculatedStats.mpReduction);
        this._summonGauge.value(MC.calculatedStats.maxSummonGauge);

        this._defense.value(MC.calculatedStats.defense);
        this._magicDefense.value(MC.calculatedStats.magicDefense);
        this._dodge.value(MC.calculatedStats.dodge);
        this._runSpeed.value(MC.calculatedStats.moveSpeed);

        // Stats not calculated on server yet
        this._criticalDamage.value(0);
        this._piercePhysical.value(0);
        this._pierceMagical.value(0);
        this._pvmOffense.value(0);
        this._pvpOffense.value(0);
        this._blockRate.value(0);
        this._blockPhysical.value(0);
        this._blockMagical.value(0);
        this._pvmDefense.value(0);
        this._pvpDefense.value(0);
        this._hpRecovery.value(0);
        this._mpRecovery.value(0);
    }
}

function _makePerc(val: any, max: any) {
    return ((val / max) * 100).toFixed(2);
}

ui.CharacterDialog = CharacterDialog;

// Helper widget for stats
class CharacterStat extends Widget {
    _element: any;
    _value: any;
    _bar: any;
    _units: string;
    _cost: any;
    _levelup: any;
    _allocateHandler: (() => void) | null;

    constructor(element: any) {
        super(element);

        this._value = ui.label(this, ".label.value");
        this._bar = ui.progressbar(this, ".progressbar.value");
        this._units = "";
        this._allocateHandler = null;

        this._cost = ui.label(this, ".label.cost");
        this._levelup = ui.button(this, ".button.levelup");

        if (this._cost) {
            this._cost.hide();
        }

        if (this._levelup) {
            this._levelup.hide();
            this._levelup.on("clicked", () => {
                if (this._allocateHandler) {
                    this._allocateHandler();
                }
            });
        }
    }

    onAllocate(handler: () => void) {
        this._allocateHandler = handler;
    }

    allocationCost(cost: number) {
        this._cost?.text(cost.toString());
    }

    allocationAvailable(available: boolean) {
        if (!this._levelup || !this._cost) {
            return;
        }

        if (available) {
            this._levelup.show();
            this._cost.show();
        } else {
            this._levelup.hide();
            this._cost.hide();
        }
    }

    unit(unit: any) {
        if (unit === undefined) {
            return this._units;
        } else {
            this._units = unit;
        }
    }

    value(value: any) {
        if (value === undefined) {
            if (this._value) {
                return this._value.text().replace(this._units, "");
            } else if (this._bar) {
                return this._bar.value();
            }
        } else if (this._value) {
            this._value.text(value + this._units);
        } else if (this._bar) {
            this._bar.value(value);
        }
    }

    min(min: any) {
        if (this._bar) {
            return this._bar.min(min);
        }
    }

    max(max: any) {
        if (this._bar) {
            return this._bar.max(max);
        }
    }
}

ui.CharacterStat = CharacterStat;
ui.charstat = ui.widgetConstructor("stat", ui.CharacterStat);

ui.characterDialog = function (inventory: any) {
    return new ui.CharacterDialog(inventory);
};
